import React, { useState, useEffect } from 'react';
import api from '../api';

function Metrics() {
    const [metrics, setMetrics] = useState([]);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchMetrics();
    }, []);

    async function fetchMetrics() {
        try {
            const res = await api.get('/metrics'); // ✅ FIXED ENDPOINT
            setMetrics(res.data);
        } catch (err) {
            setError('Failed to fetch metrics.');
        }
    }

    return (
        <div className="dashboard-container">
            <h2>API Usage Metrics</h2>
            {error && <p>{error}</p>}
            <table>
                <thead>
                    <tr>
                        <th>API</th>
                        <th>Timestamp</th>
                        <th>Requests</th>
                    </tr>
                </thead>
                <tbody>
                    {metrics.map((entry, index) => (
                        <tr key={index}>
                            <td>{entry.api_name}</td>
                            <td>{new Date(entry.timestamp).toLocaleString()}</td>
                            <td>{entry.request_count}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default Metrics;
